import {
  HeaderBackButton,
  HeaderBackButtonProps,
} from '@react-navigation/elements'
import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import { StackNavigationOptions } from '@react-navigation/stack'
import { Colors, Theme, makeStyles } from '@rneui/themed'
import { AppParamList } from 'app/types'
import { Image } from 'expo-image'
import React from 'react'
import { View } from 'react-native'
import { useThemeChange } from 'settings/change_theme'
import { PressableOpacity } from 'shared/components/pressable_opacity'

interface HeaderHomeBackButtonProps extends HeaderBackButtonProps {
  navigation: any
  theme: {
    colors: Colors
  } & Theme
  navigationRef: NavigationContainerRefWithCurrent<AppParamList>
}

export function HeaderHomeBackButton({
  navigation,
  theme,
  navigationRef,
  ...props
}: HeaderHomeBackButtonProps): React.ReactNode | undefined {
  const { index } = navigation.getState()
  const styles = useStyles()
  const { dark } = useThemeChange()
  if (!index) {
    return
  }

  const screenOptions: StackNavigationOptions | undefined =
    navigationRef.current?.getCurrentOptions()
  const presentation = screenOptions?.presentation ?? 'card'

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <HeaderBackButton {...props} onPress={() => navigation.goBack()} />
      {presentation === 'card' && index > 1 ? (
        <PressableOpacity
          onPress={() =>
            navigation.reset({ index: 0, routes: [{ name: 'home' }] })
          }
        >
          <Image
            style={styles.homeIcon}
            contentFit="cover"
            source={
              dark
                ? require('assets/routes/home_header/home-dark.png')
                : require('assets/routes/home_header/home.png')
            }
          />
        </PressableOpacity>
      ) : null}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  homeIcon: {
    width: 25,
    height: 25,
    marginRight: 3,
  },
}))
